<template>
  <div class="flex flex-col gap-3 px-4 py-6 border-separator-width border-accent-quarternary relative sm:flex-row sm:justify-between sm:items-end sm:gap-8 sm:px-6 sm:py-11">
    <slot />
  </div>
</template>
